import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../../config/theme';
import Typography from '@material-ui/core/Typography';
import CoelhoIcon from '../../../images/coelho.jpg';
import { numberAsCurrency } from '../../utils';
import moment from 'moment';
import ConfirmationNumber from '@material-ui/icons/ConfirmationNumber';
import CalendarToday from '@material-ui/icons/CalendarToday';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '96px minmax(0, 1fr) minmax(128px, auto)',
    columnGap: '16px',
    alignItems: 'stretch',
    margin: '12px 0',
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E7F0',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    padding: '16px',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '72px minmax(0, 1fr) minmax(100px, auto)',
      columnGap: '10px',
      padding: '12px',
    },
  },
  colPhoto: {
    width: '96px',
    height: '96px',
    borderRadius: '10px',
    backgroundColor: '#F0F2F5',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    [theme.breakpoints.down('xs')]: {
      width: '72px',
      height: '72px',
    },
  },
  colInfo: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '6px',
  },
  colMeta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    justifySelf: 'stretch',
    gap: '10px',
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontWeight: 700,
    color: '#1A1A1A',
    lineHeight: 1.35,
    wordBreak: 'break-word',
    '&&': {
      fontSize: '0.875rem',
    },
  },
  prizeDescription: {
    margin: 0,
    color: '#5C5C5C',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    lineHeight: 1.4,
    '&&': {
      fontSize: '0.75rem',
    },
  },
  ticketBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#E9F6E9',
    borderRadius: '8px',
    padding: '6px 10px',
  },
  ticketIcon: {
    fontSize: '0.875rem',
    color: '#1A1A1A',
    fill: '#1A1A1A',
    flexShrink: 0,
  },
  ticketBadgeNumber: {
    fontWeight: 700,
    color: '#1A1A1A',
    fontSize: '0.75rem',
    lineHeight: 1,
  },
  dateRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontWeight: 700,
    color: '#1A1A1A',
    fontSize: '0.75rem',
    marginTop: 'auto',
  },
  dateIcon: {
    fontSize: '0.875rem',
    color: '#1A1A1A',
    fill: '#1A1A1A',
    flexShrink: 0,
  },
}));

export default function InstantWinner({ winner, campaign }) {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <div className={classes.colPhoto}>
          <img src={winner?.customer?.avatar || CoelhoIcon} alt="" />
        </div>
        <div className={classes.colInfo}>
          <Typography component="h6" variant="body2" className={classes.title}>
            {winner?.customer?.name} ({winner?.customer?.cpf})
          </Typography>
          <Typography component="p" variant="body2" className={classes.prizeDescription}>
            Prêmio instantâneo de {numberAsCurrency(winner?.instant_prize_value)}
          </Typography>
        </div>
        <div className={classes.colMeta}>
          <div className={classes.ticketBadge}>
            <ConfirmationNumber className={classes.ticketIcon} />
            <span className={classes.ticketBadgeNumber}>{winner?.pretty_number}</span>
          </div>
          <div className={classes.dateRow}>
            <CalendarToday className={classes.dateIcon} />
            <span>{moment(winner?.created_at).format('DD/MM')}</span>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
